export class Settings {
    SPECTRUM_API: string;
}